<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="活动城市">
        <el-select ref="cityBox" v-model="search.city" placeholder="城市">
          <el-option label="全国" value="" />
          <el-option v-for="item in citySelectVO" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="活动时间">
        <el-date-picker ref="dateBox" v-model="search.beginTime" type="date" placeholder="选择日期" format-date />
      </el-form-item>
      <el-form-item label="活动状态">
        <el-select ref="statusBox" v-model="search.status" placeholder="选择活动状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="activity-preorder operation-bar">
      <el-button size="small" type="primary" @click="releaseActivities">
        <svg-icon icon-class="public" />
        立即发布
      </el-button>
      <el-button size="small" type="primary" @click="openRegistration">
        <svg-icon icon-class="register" />
        开放报名
      </el-button>
      <el-date-picker v-model="exportTime" type="daterange" range-separator="-" start-placeholder="活动开始时间" end-placeholder="活动结束时间" class="export-time" prefix-icon="el-icon-date" @change="handleFormatExportTime" />
      <el-button size="small" type="primary" @click="exportFixedTimeEnrollmentList">导出报名信息</el-button>
      <div class="upload-module">
        <el-upload class="upload-box" action="" :show-file-list="false" :on-change="handleTeamPushUploader" :auto-upload="false">
          <div>
            <el-button v-if="!teamExcel" class="upload-btn" size="small"><svg-icon icon-class="downLoad" />批量导入</el-button>
            <template v-else>
              <div class="file">{{ teamExcel.name }}</div>
              <el-button class="submit" size="small" @click.stop="submitTeamExcel">确认</el-button>
              <el-button class="cancel" size="small" @click.stop="cancelTeamExcel">取消</el-button>
            </template>
            <div class="coupon_tip" @click="downloadTeamFileTemplate">
              <i class="el-icon-document" />下载文件模板
            </div>
          </div>
        </el-upload>
      </div>
    </div>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed />
      <el-table-column prop="id" label="活动ID" width="100" fixed />
      <el-table-column prop="name" label="活动类型" width="auto">
        <template v-slot="scope">
          <div v-if="scope.row.type === 0" class="activity-type activity-type-common">通用</div>
          <div v-if="scope.row.type === 1" class="activity-type activity-type-private">特邀</div>
          <div v-if="scope.row.type === 2" class="activity-type activity-type-team">组队</div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="活动标题" width="150" />
      <el-table-column prop="status" label="活动状态" width="auto" min-width="100">
        <template v-slot="scope">
          <el-tag v-if="scope.row.status === 0" type="success" size="mini">已发布</el-tag>
          <el-tag v-if="scope.row.status === 1" class="el-tag--yellow" size="mini">草稿</el-tag>
          <!-- <el-tag v-if="scope.row.status === 2" class="el-tag--purple" size="mini">审核中</el-tag> -->
          <el-tag v-if="scope.row.status === 3" class="el-tag--blue" size="mini">待发布</el-tag>
          <el-tag v-if="scope.row.status === 4" class="el-tag--red" size="mini">开放报名中</el-tag>
          <el-tag v-if="scope.row.status === 5" class="el-tag--end" size="mini">已结束</el-tag>
          <el-tag v-if="scope.row.status === 6" class="el-tag--gray" size="mini">报名截止</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="beginTime" label="活动开始日期" width="auto" min-width="100">
        <template #default="{row}">
          {{ $moment(row.beginTime).format('YYYY/MM/DD') || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="city" label="活动城市" />
      <el-table-column label="报名人数/队伍" width="auto" min-width="120">
        <template v-slot="{row}">
          <template v-if="row.type ===0 || row.type ===1">
            <template v-if="row.status === 1 || row.status === 3">
              <div>--</div>
            </template>
            <template v-else>
              <div>新客：{{ row.newParticipationNumber }}</div>
              <div>老客：{{ row.oldParticipationNumber }}</div>
            </template>
          </template>
          <template v-else>
            <template v-if="row.status === 1 || row.status === 3">
              <div>--</div>
            </template>
            <template v-else>
              <div>队伍：{{ row.teamParticipation }}</div>
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column v-if="false" prop="alternateNumber" label="候补人数">
        <template v-slot="{row}">
          <span>{{ row.alternateNumber !== '' ? row.alternateNumber : '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="348px" label="操作">
        <template v-slot="{row}">
          <el-button v-if="row.status !== 5" size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="copy(row)">复制</el-button>
          <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
          <el-popover placement="bottom" width="148" style="margin:0 10px" trigger="click" :popper-options="{ removeOnDestroy: true }">
            <div style="text-align:center">
              <img :ref="`downLoadImg${row.id}`" src="" alt="" style="width:100%;">
              <el-button size="small" type="text" class="link-color" @click="downQrCode(row)">下载二维码</el-button>
            </div>
            <el-button slot="reference" size="small" type="text" class="link-color" @click="getErcode(row)">二维码</el-button>
          </el-popover>
          <el-button size="small" type="text" class="link-color" @click="handleShare(row)">分享</el-button>
          <!-- <el-button v-if="row.status === 2" size="small" type="text" class="link-color" @click="audit(row)">审核</el-button> -->
          <el-button v-if="row.status === 3" size="small" type="text" class="link-color" @click="release(row)">发布</el-button>
          <el-button v-if="[4,5,6].includes(row.status)" size="small" type="text" class="link-color" @click="exportEnrollmentList(row)">报名名单</el-button>
          <el-button v-if="row.needIdCard === 0" size="small" type="text" class="link-color" @click="handleExportIds(row.id)">身份证信息表</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="fixed-below" :page-size="pageSize" layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50, 100]" :current-page.sync="pageNum" :total="total" @size-change="handleSizeChange" @current-change="getList" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
    <el-dialog v-if="showShare" :visible.sync="showShare" title="选择需要分享的链接类型" custom-class="share-wrapper" @close="handleResetShare">
      <el-form ref="shareBox" class="share-form" :model="shareForm" :rules="shareRules">
        <el-form-item label="是否加参" prop="isHaveParameter">
          <el-radio v-model="shareForm.isHaveParameter" :label="1" @change="handleHideTabs">不需要</el-radio>
          <el-radio v-model="shareForm.isHaveParameter" :label="0" @change="handleHideTabs">需要</el-radio>
        </el-form-item>
        <el-form-item label="分享方式" prop="shareWay">
          <el-select v-model="shareForm.shareWay" placeholder="请选择分享方式" style="width: 150px;" @change="handleChangeShareWay">
            <el-option v-for="item in shareList" :key="item.id" :label="item.value" :value="item.id" />
          </el-select>
        </el-form-item>
        <template v-if="!shareForm.isHaveParameter">
          <div class="info-wrapper">
            <div class="split" />
            <div class="info-title">基础信息</div>
            <el-form-item label="描述文字" prop="description">
              <el-input v-model="shareForm.description" placeholder="请输入描述文字" style="width: 407px" />
            </el-form-item>
            <div style="display: flex">
              <el-form-item label="活动名称" style="margin-right: 40px;">
                <el-input v-model="shareForm.activityName" disabled placeholder="请输入活动名称" style="width: 150px" />
              </el-form-item>
              <el-form-item label="活动类型" prop="activityType">
                <el-select v-model="shareForm.activityType" placeholder="请选择分享方式" style="width: 150px;" @change="handleChangeActivityType">
                  <el-option v-for="item in shareSelect.activityType" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </div>
            <div class="share-form-detail">
              <el-form-item label="活动时间:">
                <span :title="shareForm.activeTime">{{ shareForm.activeTime || '' }}</span>
              </el-form-item>
              <el-form-item label="活动城市:">
                <span :title="shareForm.city">{{ shareForm.city || '' }}</span>
              </el-form-item>
              <el-form-item label="活动门店:">
                <span :title="shareForm.addressName">{{ shareForm.addressName || '' }}</span>
              </el-form-item>
            </div>

          </div>
          <div class="info-wrapper">
            <div class="split" />
            <div class="info-title">参数选择</div>
            <div style="display: flex">
              <el-form-item label="Channel" class="chanel" prop="utmChannel">
                <el-select v-model="shareForm.utmChannel" placeholder="请选择" style="width: 150px;" @change="handleRelationSource">
                  <el-option v-for="item in shareSelect.utmChannel" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="Source" class="source" prop="utmSource">
                <el-select v-model="shareForm.utmSource" placeholder="请选择" style="width: 150px; margin-right: 10px;" @change="handleRelationChannel">
                  <el-option v-for="item in shareSelect.utmSource" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <el-input v-if="handleFindOther()" v-model="shareForm.utmSourceContent" placeholder="请输入" style="width: 120px" />
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item label="UTM campaign" class="utmCampaign" prop="utmCampaign">
                <el-input v-model="shareForm.utmCampaign" placeholder="请输入活动名称" style="width: 150px" />
              </el-form-item>
              <el-form-item label="UTM media">
                <el-select v-model="shareForm.utmMedium" placeholder="请选择" style="width: 150px;" @change="handleChangeShareWay">
                  <el-option v-for="item in shareSelect.utmMedium" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </div>
            <div style="display: flex">
              <el-form-item label="utm_content" class="utm_content">
                <el-input v-model="shareForm.utmContent" placeholder="请输入utm_content" style="width: 150px" />
              </el-form-item>
              <el-form-item label="utm_term" class="utm_term">
                <el-input v-model="shareForm.utmTerm" placeholder="请输入utm_term" style="width: 150px" />
              </el-form-item>
            </div>
          </div>
        </template>
        <el-form-item class="share-form-btn">
          <el-button type="primary" @click="handleShowTabs">生成链接/二维码</el-button>
        </el-form-item>
      </el-form>
      <template v-if="showTabs && !Object.values(shareData).some(item=>!item)">
        <el-tabs v-model="activeTab" class="tabs-wrapper" style="padding-left: 30px; padding-right: 29px">
          <el-tab-pane :label="`${shareList[shareForm.shareWay].value}二维码`" name="code">
            <div class="code-wrapper">
              <div class="code-img">
                <img ref="shareDataImg" :src="shareForm.shareWay===0 ?shareData.miniProgramQrCode : shareData.h5QrCode" alt="">
              </div>
              <el-button type="primary" @click="handleDownQrCode">下载二维码</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="`${shareList[shareForm.shareWay].value}链接`" name="link">
            <div class="link-wrapper">
              <div class="link-content">
                <p ref="copyLink" class="content">
                  {{ shareForm.shareWay===0 ? shareData.miniProgramLinks :shareData.h5Links }}
                </p>
              </div>
              <el-button type="primary" @click="copyLink">复制链接</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </el-dialog>
    <el-dialog v-if="showCoachDialog" :visible.sync="showCoachDialog" title="报名审核" width="432px">
      <el-form label-width="100px">
        <el-form-item class="coach-form" label="教练头像">
          <div class="coach-header">
            <img alt="" :src="selectCoachItem.headImgUrl">
          </div>
        </el-form-item>
        <el-form-item label="教练姓名">
          <span>{{ selectCoachItem.name }}</span>
        </el-form-item>
        <el-form-item label="教练昵称">
          <span>{{ selectCoachItem.nickname }}</span>
        </el-form-item>
        <el-form-item label="性别">
          <span>{{ selectCoachItem.sexName }}</span>
        </el-form-item>
        <el-form-item label="教练级别">
          <span>{{ selectCoachItem.level }}</span>
        </el-form-item>
        <el-form-item label="城市">
          <span>{{ selectCoachItem.city }}</span>
        </el-form-item>
        <el-form-item label="运动类别">
          <span>{{ selectCoachItem.movementTypeName }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="postActivityCheck(selectCoachItem.activityId, false)">不通过</el-button>
        <el-button type="primary" @click="postActivityCheck(selectCoachItem.activityId, true)">通过</el-button>
      </span>
    </el-dialog>
    <el-dialog class="feedback-dialog" :visible.sync="importStatus" title="导入反馈">
      <div class="txt-cont">
        <div v-if="importCallBackList.length" class="error-cont">
          <span>详情：</span>
          <div class="error-list">
            <p v-for="(item, index) in importCallBackList" :key="index" class="error-li">{{ item }}</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import { mapActions, mapState } from 'vuex';
import { formatDate, formatDate1 } from '@/filters';
import Dialog from '@/components/Dialog';
import FunctionUtils from '@/utils/functionUtils';
import { getFileType, imatateDownloadByA } from "@/common/js/util";
export default {
  components: { Dialog },

  data() {
    const statusList = [
      { id: 0, value: '已发布' },
      { id: 1, value: '草稿' },
      // { id: 2, value: '审核中' },
      { id: 3, value: '待发布' },
      { id: 4, value: '开放报名中' },
      { id: 6, value: '报名截止' },
      { id: 5, value: '已结束' },
    ];
    return {
      enter: -1,
      activeTab: 'code',
      showTabs: false,
      showShareDialog: false,
      showCoachDialog: false,
      showShare: false,
      list: [],
      activityIds: [],
      statusList: statusList,
      shareSelect: {
        activityType: [],
        utmChannel: [],
        utmContent: [],
        utmMedium: [],
        utmSource: [],
      },
      shareForm: {
        isHaveParameter: 1,
        shareWay: 0,
        activityId: '',
        activityName: '',
        activityType: null,
        description: '',
        activeTime: '',
        city: '',
        addressName: '',
        utmChannel: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: '',
        utmSourceContent: '',
        utmContent: '',
        utmTerm: '',
      },
      shareList: [
        { id: 0, value: '小程序' },
        { id: 1, value: 'H5' },
      ],
      shareData: {
        h5Links: '',
        h5QrCode: '',
        miniProgramLinks: '',
        miniProgramQrCode: '',
      },
      exportTime: null,
      exportTimes: {
        beginTime: '',
        endTime: '',
      },
      info: {
        text: '',
      },
      shareQr: '',
      search: {
        city: '',
        status: '',
        text: '',
        beginTime: '',
      },
      searchSubmitted: {},
      pageSize: 10,
      pageNum: 0,
      total: 0,
      formDialogShow: false,
      currentID: -1,
      information: {},
      selectCoachItem: {},
      shareRules: {
        isHaveParameter: [{ required: true, message: '请选择是否需要加参', trigger: 'change' }],
        shareWay: [{ required: true, message: '请选择分享方式', trigger: 'change' }],
      },
      teamExcel: null,
      importStatus: false,
      importCallBackList: [],
    };
  },
  computed: {
    ...mapState('activity', ['citySelectVO']),
  },
  beforeRouteLeave(to, from, next) {
    const list = ['/activity/ua/edit', '/activity/ua/add'];
    if (!list.includes(to.path)) {
      this.enter = 0;
      this.searchSubmitted = {};
      this.search = {
        city: '',
        id: '',
        name: '',
        beginTime: '',
        status: '',
      };
      this.pageNum = 1;
    }
    next();
  },
  activated() {
    this.enter += 1;
    if (this.enter) {
      this.searchSubmit();
    }
  },
  mounted() {
    this.getList();
    this.getSelect();
    this.fetchBuriedChannel();
    window.addEventListener('scroll', () => {
      // 城市滚动关闭
      this.$refs.cityBox && this.$refs.cityBox.handleClose();
      // 活动时间滚动关闭
      this.$refs.dateBox && this.$refs.dateBox.handleClose();
      // 活动状态滚动关闭
      this.$refs.statusBox && this.$refs.statusBox.handleClose();
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', null);
  },
  methods: {
    /** 批量导入 */
    handleTeamPushUploader(file) {
      if (getFileType(file.raw.name) !== "excel") {
        this.$message.error("导入失败，请选择Excel文件");
        return;
      }
      this.teamExcel = file.raw;
    },
    /** 确认批量导入 */
    submitTeamExcel() {
      if (!this.teamExcel) {
        this.$message.warning("请先选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.teamExcel);
      this.$Api.activity.uploadUaStarList(formData).then(res => {
        if (res && res.length) {
          this.importStatus = true;
          this.importCallBackList = res;
        } else {
          this.$message.success(`已成功导入活动信息`);
          this.getList();
        }
      });
    },
    /** 取消批量导入 */
    cancelTeamExcel() {
      this.teamExcel = null;
    },
    /** 批量导入 下载文件模板 */
    downloadTeamFileTemplate() {
      const fileUrl = "https://uaprd-1257321318.cos.ap-beijing.myqcloud.com/static/excel/addUaStarV3.xlsx";
      window.open(fileUrl);
    },
    // 重置分享表单
    handleResetShare() {
      this.shareData = {
        h5Links: '',
        h5QrCode: '',
        miniProgramLinks: '',
        miniProgramQrCode: '',
      };
      this.shareForm = {
        isHaveParameter: 1,
        shareWay: 0,
        activityId: '',
        activityName: '',
        activityType: null,
        description: '',
        activeTime: '',
        city: '',
        addressName: '',
        utmChannel: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: '',
        utmSourceContent: '',
        utmContent: '',
        utmTerm: '',
      };
      this.activeTab = 'code';
      this.handleChangeShareRules();
    },
    handleFindOther() {
      if (!this.shareForm.utmSource) return false;
      const { name } = this.shareSelect.utmSource.find(item => item.id === this.shareForm.utmSource);
      return name === '其他';
    },
    handleRelationChannel(val) {
      this.shareForm.utmSourceContent = '';
      if (!this.shareForm.utmChannel && val === -99) {
        this.shareForm.utmSource = null;
        this.$message.warning('请先选择Channel，再选择其他');
        return;
      }
      if (val === -99) return;
      this.shareForm.utmChannel = null;
      this.$Api.activity.buriedChannelSelectTwoStageLinkage({
        utmSourceId: val,
      }).then(res => {
        if (res && res.length) {
          this.shareForm.utmChannel = this.shareSelect.utmChannel.find(item => item.name === res[0].name).id;
        }
      });
    },
    //  Channel关联Source
    handleRelationSource(val) {
      this.shareForm.utmSourceContent = '';
      this.shareForm.utmSource = null;
      this.$Api.activity.buriedChannelSelectTwoStageLinkage({
        utmChannelId: val,
      }).then(res => {
        if (res && res.length) {
          this.shareSelect.utmSource = [...res, {
            "id": -99,
            "parentId": null,
            "type": 1,
            "name": "其他",
            "remark": "",
          }];
          this.$refs.shareBox.validateField('utmSource');
        }
      });
    },
    // 处理导出时间
    handleFormatExportTime(val) {
      this.exportTimes = {
        beginTime: '',
        endTime: '',
      };
      if (val && val.length) {
        this.exportTimes = {
          beginTime: formatDate(val[0]),
          endTime: formatDate(val[1]),
        };
      }
    },
    // 导出固定时限的报名名单
    exportFixedTimeEnrollmentList() {
      if (!this.exportTimes.beginTime || !this.exportTimes.endTime) {
        this.$message.error('请先选择活动开始、结束时间');
        return;
      }
      this.$Api.activity.exportFixedTimeEnrollmentList(this.exportTimes).then(res => {
        if (!res) {
          this.$message.error('该时间段暂无报名人员');
        } else {
          this.$message.success('导出成功');
        }
      });
    },
    fetchBuriedChannel() {
      this.$Api.activity.buriedChannelSelect().then(res => {
        if (res) {
          if (res.utmChannel && res.utmChannel.length) {
            res.utmChannel = FunctionUtils.objectReset(res.utmChannel, 'name');
          }
          if (res.utmSource && res.utmSource.length) {
            res.utmSource.push({
              "id": -99,
              "parentId": null,
              "type": 1,
              "name": "其他",
              "remark": "",
            });
          }
          this.shareSelect = res;
        }
      });
    },
    handleHideTabs(val) {
      this.handleChangeShareRules();
      this.showTabs = false;
    },

    // 动态改变校验规则
    handleChangeShareRules() {
      if (this.shareForm.isHaveParameter === 1) {
        this.shareRules = {
          isHaveParameter: [{ required: true, message: '请选择是否需要加参', trigger: 'change' }],
          shareWay: [{ required: true, message: '请选择分享方式', trigger: 'change' }],
        };
      } else {
        this.shareRules = {
          ...this.shareRules,
          description: [{ required: true, message: '请输入描述文字', trigger: 'blur' }],
          activityType: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
          utmChannel: [{ required: true, message: '请选择Channel', trigger: 'change' }],
          utmSource: [{
            required: true, validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请选择Source'));
              }
              const obj = this.shareSelect.utmSource.find(item => item.id === value);
              if (obj && obj.name === '其他' && !this.shareForm.utmSourceContent) {
                callback(new Error('请输入Source'));
              } else {
                callback();
              }
            }, trigger: 'change',
          }],
          utmCampaign: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        };
      }
    },
    // 改变活动类型
    handleChangeActivityType(val) {
      this.$Api.activity.buriedChannelCampaign({
        activityId: this.shareForm.activityId,
        activityType: val,
      }).then(res => {
        if (res) {
          this.shareForm.utmCampaign = res;
          this.$refs.shareBox.validateField('utmCampaign');
        }
      });
    },
    // 改变分享方式
    handleChangeShareWay() {
      this.activeTab = 'code';
      this.handleHideTabs();
    },
    // 生成二维码，链接
    handleShowTabs() {
      const params = this.handleDealParams();
      console.log(params);
      this.$refs.shareBox.validate(valid => {
        if (valid) {
          // 不需要带参
          if (this.shareForm.isHaveParameter === 1) {
            this.$Api.activity.buriedChannel({
              activityId: this.currentID,
              isHaveParameter: this.shareForm.isHaveParameter,
              objectType: 3, //  普通活动
            }).then(res => {
              res && (this.shareData = res);
              this.showTabs = true;
            });
          } else {
            const params = this.handleDealParams();
            this.$Api.activity.buriedChannel(params).then(res => {
              res && (this.shareData = res);
              this.showTabs = true;
            });
          }
        }
      });
    },
    // 处理活动带参
    handleDealParams() {
      const defaultParams = {
        objectType: 3, //  普通活动
        activityId: this.shareForm.activityId,
        activityName: this.shareForm.activityName,
        isHaveParameter: this.shareForm.isHaveParameter,
      };
      if (this.shareForm.activityType) {
        defaultParams['activityType'] = this.shareForm.activityType;
      }
      if (this.shareForm.description) {
        defaultParams['description'] = this.shareForm.description;
      }
      if (this.shareForm.utmCampaign) {
        defaultParams['utmCampaign'] = this.shareForm.utmCampaign;
      }
      if (this.shareForm.utmChannel && this.shareSelect.utmChannel && this.shareSelect.utmChannel.length) {
        const { name } = this.shareSelect.utmChannel.find(item => item.id === this.shareForm.utmChannel);
        name && (defaultParams['utmChannel'] = name);
      }
      if (this.shareForm.utmSource && this.shareSelect.utmSource && this.shareSelect.utmSource.length) {
        const { name } = this.shareSelect.utmSource.find(item => item.id === this.shareForm.utmSource);
        if (name === '(空)') {
          defaultParams['utmSource'] = null;
        } else if (name === '其他') {
          defaultParams['utmSource'] = this.shareForm.utmSourceContent;
        } else {
          defaultParams['utmSource'] = name;
        }
      }
      if (this.shareForm.utmMedium && this.shareSelect.utmMedium && this.shareSelect.utmMedium.length) {
        const { name } = this.shareSelect.utmMedium.find(item => item.id === this.shareForm.utmMedium);
        defaultParams['utmMedium'] = name;
      }
      if (this.shareForm.utmContent) {
        defaultParams['utmContent'] = this.shareForm.utmContent;
      }
      if (this.shareForm.utmTerm) {
        defaultParams['utmTerm'] = this.shareForm.utmTerm;
      }
      return defaultParams;
    },
    // 下载活动分享带参/不带参二维码
    handleDownQrCode() {
      if (!this.$refs.shareDataImg || !this.$refs.shareDataImg.src) return;
      imatateDownloadByA(this.$refs.shareDataImg.src, `${this.shareForm.name || '活动分享'}.png`);
    },
    // 复制活动分享链接
    copyLink() {
      if (!this.$refs.copyLink && !this.$refs.copyLink.innerText) return;
      navigator.clipboard.writeText(this.$refs.copyLink.innerText).then(() => {
        this.$message.success('复制成功');
      });
    },
    handleExportIds(activityId) {
      this.$Api.activity.exampleExportTheIDCardInformationTable(activityId).then((res) => {
        if (!res) {
          this.$message.error('该活动暂无报名人员');
        } else {
          this.$message.success('导出成功');
        }
      });
    },
    handleShare(row) {
      const activeTime = `${formatDate1(row.beginTime)} - ${formatDate1(row.endTime)}`;
      this.currentID = row.id;
      this.shareForm = {
        ...this.shareForm,
        activityId: row.id,
        activityName: row.name,
        activeTime: activeTime,
        city: row.city,
        addressName: row.addressName,
      };
      this.showShare = true;
    },
    ...mapActions('activity', ['getSelect']),
    // 审核
    audit(row) {
      this.showCoachDialog = true;
      this.$Api.coach.getCoachDetails(row.coachId).then(res => {
        res.activityId = row.id;
        res.sexName = {
          0: '未知',
          1: '男',
          2: '女',
        }[res.sex];
        res.movementTypeName = res.movementTypeSelectVOS.reduce((init, item) => {
          init.push(item.tagName);
          return init;
        }, []).join('/');
        this.selectCoachItem = Object.assign(res);
      });
    },
    // 审核是否通过
    postActivityCheck(activityId, isCheck) {
      this.$Api.activity.postActivityCheck({
        activityId,
        isCheck,
      }).then(res => {
        this.showCoachDialog = false;
        this.$message.success(`${isCheck ? '审核通过' : '审核不通过'}`);
        this.getList();
      });
    },
    // 发布
    release(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'release',
        icon: 'warn',
        subTitle: `是否确认发布活动ID为“${this.currentID}”的数据项？`,
      };
    },
    handleSelectionChange(val) {
      this.activityIds = val.map(item => item.id);
    },
    add() {
      this.$router.push({ path: '/activity/ua/add' });
    },
    edit(row) {
      if ([0, 2, 4].indexOf(row.status) !== -1) {
        this.formDialogShow = true;
        this.currentID = row.id;
        const subTitle = row.status === 0 ? '活动已发布，编辑将会更新活动信息，是否继续？' : '活动已开放报名，编辑将会更新活动信息，是否继续？';
        this.information = {
          operation: 'edit',
          icon: 'warn',
          subTitle: subTitle,
        };
      } else {
        this.$router.push({ path: '/activity/ua/edit', query: { id: row.id } });
      }
    },
    remove(row) {
      this.currentID = row.id;
      this.$Api.activity.activityStatusById(row.id).then(res => {
        // 0可报名，1已预约，2已报名，3取消报名，4已签到，5可预约,6已满员，7.已结束，8不可取消,9活动已取消,10活动正在进行,11已经有人签到
        if ([10, 11].indexOf(res) !== -1) {
          this.information = {
            icon: 'error',
            subTitle: `活动已有人签到，无法删除！`,
          };
        } else {
          this.information = {
            operation: 'delete',
            icon: 'warn',
            subTitle: '删除后小程序用户将无法查看该活动，请确认是否删除',
            // subTitle: `是否确认删除活动ID为“${row.id}”的数据项？`,
          };
        }
        this.formDialogShow = true;
      });
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.$Api.activity.deleteActivity({ activityIds: this.currentID }).then(() => {
          this.$message.success('删除成功');
          this.pageNum = (this.pageNum -= this.list.length === 1 && 1) ? 1 : this.pageNum;
          this.getList();
        });
      } else if (operation === 'copy') {
        this.$router.push({ path: '/activity/ua/add', query: { copyid: this.currentID } });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/activity/ua/edit', query: { id: this.currentID } });
      } else if (operation === 'release') {
        this.$Api.activity.releaseActivities({ activityIds: [this.currentID].join(',') }).then(() => {
          this.$message.success('发布成功');
          this.getList();
        });
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    getList() {
      //  调用api获取数据
      this.$Api.activity.activityList({
        limit: this.pageSize,
        current: this.pageNum,
        ...this.searchSubmitted,
      }).then(({ data, total }) => {
        this.list = data;
        this.total = total;
      });
    },
    searchSubmit() {
      this.searchSubmitted = {};
      Object.keys(this.search).forEach(key => {
        if (key === 'beginTime') {
          this.searchSubmitted['beginTime'] = formatDate(this.search[key]);
        } else {
          this.searchSubmitted[key] = this.search[key];
        }
      });
      this.pageNum = 0;
      this.getList();
    },
    reset() {
      this.searchSubmitted = {};
      this.search = {
        city: '',
        id: '',
        name: '',
        beginTime: '',
        status: '',
      };
      this.pageNum = 1;
      this.getList();
    },
    releaseActivities() {
      this.$Api.activity.releaseActivities({ activityIds: this.activityIds.join(',') })
        .then(() => {
          this.$message.success('发布成功');
          this.getList();
        });
    },
    openRegistration() {
      this.$Api.activity.openRegistration({ activityIds: this.activityIds.join(',') })
        .then(() => {
          this.$message.success('开放报名成功');
          this.getList();
        });
    },
    exportEnrollmentList(row) {
      if (row.type === 2) {
        this.$Api.activity.exportEnrollmentTeamList(row.id)
          .then((res) => {
            if (!res) {
              this.$message.error('该活动暂无报名人员');
            } else {
              this.$message.success('导出成功');
            }
          });
      } else {
        this.$Api.activity.exportEnrollmentList(row.id)
          .then((res) => {
            if (!res) {
              this.$message.error('该活动暂无报名人员');
            } else {
              this.$message.success('导出成功');
            }
          });
      }
    },
    // 下载二维码
    downQrCode(row) {
      // 创建a链接下载
      const link = document.createElement('a');
      link.href = this.$refs[`downLoadImg${row.id}`].src;
      link.download = `${row.name}.png`;
      link.target = '_blank';
      link.click();
    },
    getErcode(row) {
      this.$Api.activity.getActivityCode(row.id).then((res) => {
        this.$refs[`downLoadImg${row.id}`].src = res;
      });
    },
  },
};

</script>
<style lang="less" scoped>
.mr30 {
  margin-right: 30px;
}
/deep/.feedback-dialog {
  .txt-cont {
    margin-bottom: 12px;
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #494949;
  }
  .error-cont {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    max-height: 300px;
    overflow-y: auto;
    .error-list {
      flex: 1;
      width: 100%;
    }
  }
}
.upload-module {
  margin-left: 37px;
  .el-upload {
    > div {
      display: flex;
      align-items: center;
      > .file {
        color: #0085d0;
        margin-right: 15px;
        font-size: 14px;
        text-decoration: underline;
        text-underline-offset: 2px;
      }
      > button {
        box-sizing: border-box;
        color: #fff;
        background-color: #1c1c1c;
        border-color: #1c1c1c;
        &.upload-btn {
          width: 136px;
          svg {
            margin-right: 4px;
          }
        }
        &.submit {
          width: 62px;
        }
        &.cancel {
          width: 62px;
          border: 1px solid #e3e3e5;
          color: #494949;
          background: none;
        }
      }
      .coupon_tip {
        margin-left: 30px;
        font-size: 14px;
        color: #0085d0;
        i {
          margin-right: 5px;
        }
      }
    }
  }
}
.export-time {
  width: 308px;
  height: 32px;
  margin: 0 37px 0 57px;
  padding: 0 10px;
  /deep/.el-range-separator {
    color: #494949 !important;
  }
  .el-range-editor.el-input__inner {
    padding: unset;
  }
}
.coach-form {
  .coach-header {
    overflow: hidden;

    width: 50px;
    height: 50px;

    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.activity-type {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;

  width: 58px;
  height: 22px;
  padding: 4px 11px;

  color: #fff;
  background: #494949;

  font-size: 14px;

  &.activity-type-private {
    background: #caa670;
  }
  &.activity-type-team {
    background: #dc0019;
  }
}
.el-tag {
  font-size: 14px;
  font-weight: 400;
}

.share-dialog {
  /deep/.el-dialog {
    width: 804px;
    //padding-left: 30px;
    //padding-right: 30px;
    padding: 30px 30px 37px 30px;
    .el-dialog__header {
      padding: unset;
      .el-dialog__title {
        color: #000000;

        font-family: "Noto Sans SC";
        font-size: 16px;
        font-weight: 400;
        font-style: normal;
        line-height: 23px;
      }
    }
    .el-dialog__body {
      height: 324px;
      margin-top: 25px;
      padding: unset;
      .share-box {
        display: flex;

        width: 100%;
        height: 100%;

        .content-box {
          display: flex;
          flex: 1;
          flex-direction: column;

          height: 100%;
          padding: 30px 24px 29px 24px;

          text-align: center;

          background-color: #f7f7f7;
          .content-title {
            color: #000000;

            font-family: "Noto Sans SC";
            font-size: 20px;
            font-weight: 500;
            font-style: normal;
            line-height: 29px;
          }
          .content-link-box {
            height: 142px;
            margin-top: 40px;
            margin-bottom: 20px;
            padding: 23px;

            text-align: left;

            color: #000000;
            background: #eeeeee;

            font-family: "Noto Sans SC";
            font-size: 16px;
            font-weight: 400;
            font-style: normal;
            line-height: 24px;
          }
          .qr-code {
            margin: 28px 0;
            img {
              width: 146px;
              height: 146px;
            }
          }
        }
      }
    }
  }
}
.el-dialog__wrapper {
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;

  max-height: calc(100vh - 66px - 30px - 30px);
  margin-top: 96px;
  margin-bottom: 30px;
  /deep/ .share-wrapper {
    width: 678px;
    margin: unset !important;
    .el-dialog__header {
      box-sizing: border-box !important;
      height: 6.85vh !important;
      padding: 0 2.87vh 0 2.78vh !important;

      background: #000000 !important;

      line-height: 6.85vh;
      .el-dialog__title {
        color: #ffffff;

        font-family: "Noto Sans SC";
        font-size: 1.48vh;
        font-weight: 500;
        font-style: normal;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;

        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      overflow-y: auto;

      max-height: calc(100vh - 6.85vh - 66px - 30px - 30px);
      padding: 2.5vh 0 2.78vh 0;
      .share-form {
        box-sizing: border-box;
        padding-left: 30px;
        .el-form-item {
          display: flex;
        }
        .utmCampaign {
          margin-right: 10px;
          .el-input {
            margin-left: -8px;
          }
          .el-form-item__error {
            left: -8px;
          }
        }
        .share-form-btn {
          justify-content: center;

          margin-bottom: unset;
          margin-left: -30px;
          .el-form-item__content {
            margin-left: unset !important;

            text-align: center;
            .el-button {
              height: 4.63vh;
              padding: 0 1.85vh;

              line-height: 4.63vh;
              span {
                font-family: "Noto Sans SC";
                font-size: 1.48vh;
                font-weight: 400;
                font-style: normal;
              }
            }
          }
        }
        .info-wrapper {
          .share-form-detail {
            display: flex;
            overflow-x: hidden;
            flex-wrap: nowrap;
            justify-content: space-between;

            margin-right: 30px;

            text-overflow: ellipsis;
            .el-form-item {
              white-space: nowrap;
              span {
                overflow: hidden;

                margin-right: 10px;

                text-overflow: ellipsis;
              }
            }
          }
          .chanel {
            margin-right: 10px;
            .el-form-item__label {
              width: 108.96px;

              white-space: nowrap;
            }
          }
          .source {
            .el-form-item__label {
              width: 84.63px;

              white-space: nowrap;
            }
          }
          .utm_content {
            margin-right: 10px;
            .el-form-item__label {
              width: 108.96px;

              white-space: nowrap;
            }
          }
          .utm_term {
            .el-form-item__label {
              width: 84.63px;

              white-space: nowrap;
            }
          }
          .split {
            width: 600px;
            height: 1px;

            background: #e3e3e5;
          }
          .info-title {
            margin: 20px 0;

            color: #000000;

            font-family: "Noto Sans SC";
            font-size: 1.44vh;
            font-weight: 500;
            font-style: normal;
          }
        }
      }
      .tabs-wrapper {
        .code-wrapper {
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          .code-img {
            width: 13.89vh;
            height: 13.89vh;
            margin-bottom: 2.78vh;
            img {
              width: 100%;
            }
          }
          .el-button {
            height: 3.15vh;
            padding: 0 1.85vh;

            line-height: 3.15vh;
            span {
              font-family: "Noto Sans SC";
              font-size: 1.48vh;
              font-weight: 400;
              font-style: normal;
            }
          }
        }
        .link-wrapper {
          text-align: center;
          .link-content {
            height: 13.89vh;
            margin-bottom: 2.78vh;
            padding: 1.85vh 1.39vh;

            text-align: left;

            color: #000000;
            border: 1px solid #e3e3e5;
            border-radius: 0.37vh;
            background: #eeeeee;

            font-family: "Noto Sans SC";
            font-size: 1.48vh;
            line-height: 2.22vh;
            .content {
              overflow: hidden;

              height: 11.11vh;

              text-overflow: ellipsis;
            }
          }
          .el-button {
            height: 3.15vh;
            padding: 0 1.85vh;

            line-height: 3.15vh;
            span {
              font-family: "Noto Sans SC";
              font-size: 1.48vh;
              font-weight: 400;
              font-style: normal;
            }
          }
        }
      }
    }
  }
}
</style>
